/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import errorCode from '../../errorCode'; // 進行後端error code提示
import router from '@/modules/FPKG-20000-Util/vueRouter'; // lists 使用的router
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通
import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import TimeFormater from '@/modules/FPKG-20000-Util/converter/timeFormater';


type crud = number // crud


// validate
class Modify {
  private request: any;

  constructor(request?: object) {
    this.request = request;
  }

  public async get(): Promise<object> {
    const params = this.request;
    const d = await $http.get('transaction/department/info', { params });
    if (d.data.code === 0) {
      const result = d.data.response;
      if (result.length > 0) {
        // 找出不重覆的部門
        const set = new Set();
        const dep = result.filter((item: any) => (!set.has(item.p9_ton_p6_dnt_id) ? set.add(item.p9_ton_p6_dnt_id) : false)).map((itme: any) => {
          itme.stored = 0;
          itme.auction = 0;
          itme.stored_count = 0;
          itme.auction_count = 0;
          itme.subTotal = 0;
          return itme;
        });
        // 跑兩個迴圈做資料整理
        dep.forEach((dep: any) => {
          result.forEach((res: any) => {
            if (res.p9_ton_p6_dnt_id === dep.p9_ton_p6_dnt_id) {
              if (res.p9_ton_type === 'STORED') {
                dep.stored += Number(res.p9_ton_amount);
                dep.stored_count = Number(res.p9_ton_count);
              }
              if (res.p9_ton_type === 'AUCTION') {
                dep.auction += Number(res.p9_ton_amount);
                dep.auction_count = Number(res.p9_ton_count);
              }
              dep.subTotal = dep.stored - dep.auction;
            }
          });
        });
        return dep;
      }
      return [];
    }
    try {
      throw errorCode(d.data);
    } catch (error) {
      return [];
    }
  }
}


export default Modify;
